import React from "react";

export default function Base({}) {
	return <>
		<path d="M15.6667 0C24.3333 0 31.3333 6.66667 31.3333 14.7778V83.2222C31.3333 91.3333 24.3333 98 15.6667 98C7 98 0 91.3333 0 83.2222V14.7778C0 6.66667 7 0 15.6667 0ZM82.3333 0C91 0 98 6.66667 98 14.7778V83.2222C98 91.3333 91 98 82.3333 98C73.6667 98 66.6667 91.3333 66.6667 83.2222V14.7778C66.6667 6.66667 73.6667 0 82.3333 0ZM49 0C57.6667 0 64.6667 6.66667 64.6667 14.7778V83.2222C64.6667 91.3333 57.6667 98 49 98C40.3333 98 33.3333 91.3333 33.3333 83.2222V14.7778C33.3333 6.66667 40.3333 0 49 0Z"/>
	</>
}